import { render, staticRenderFns } from "./ImportPRMRecords.vue?vue&type=template&id=2b1840fc"
import script from "./ImportPRMRecords.vue?vue&type=script&lang=js"
export * from "./ImportPRMRecords.vue?vue&type=script&lang=js"
import style0 from "./ImportPRMRecords.vue?vue&type=style&index=0&id=2b1840fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports